<template>
  <div>
    <navbar-bottom
      :visible="isVisible"
      :feeds="feeds"
      :routeName="routeName"
      v-on:scrolling="resetTimeout"
    />
    <navbar-go-to-top :visible="isVisible"/>
  </div>
</template>

<script>
import NavbarBottom from "@/components/Navbars/Navbar.Bottom.vue";
import NavbarGoToTop from "@/components/Navbars/Navbar.GoToTop.vue";

export default {
  name: "NavbarDynamicBars",
  components: {
    NavbarBottom,
    NavbarGoToTop
  },
  data: function() {
    return {
      isVisible: false,
      visibleTimer: null
    };
  },
  props: {
    feeds: Object,
    routeName: String
  },
  methods: {
    handleScroll() {
      //body for Safari
      //documentElement for Chrome, Firefox, IE and Opera
      this.isVisible = document.body.scrollTop > 140 || document.documentElement.scrollTop > 140;

      if (window.innerWidth < 576) {
        this.resetTimeout();
        this.visibleTimer = setTimeout(() => {
          this.isVisible = false;
        }, 2000);
      }
    },
    resetTimeout() {
      clearTimeout(this.visibleTimer);
    }
  },
  created() {
    document.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
